var _defs, _path, _path2, _path3, _rect, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew288({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.21,8.5l.22,0a.85.85,0,0,0,.08.28.69.69,0,0,0,.18.16A.58.58,0,0,0,13,9a.54.54,0,0,0,.33-.1.37.37,0,0,0,.11-.27.27.27,0,0,0,0-.16.3.3,0,0,0-.13-.12,2.33,2.33,0,0,0-.36-.13A1.43,1.43,0,0,1,12.5,8a.49.49,0,0,1-.16-.19.53.53,0,0,1-.06-.26.57.57,0,0,1,.17-.42A.61.61,0,0,1,12.9,7a.75.75,0,0,1,.35.08.61.61,0,0,1,.23.22.74.74,0,0,1,.08.34l-.22,0a.43.43,0,0,0-.13-.31.52.52,0,0,0-.6,0,.29.29,0,0,0-.1.23.24.24,0,0,0,.07.2.91.91,0,0,0,.34.15l.37.12a.6.6,0,0,1,.33.54.69.69,0,0,1-.09.34.66.66,0,0,1-.24.23.72.72,0,0,1-.35.08.7.7,0,0,1-.52-.2A.77.77,0,0,1,12.21,8.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14,9.19v-.3h.25v.3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.07,9.19V7.29h-.58V7h1.39v.25H15.3v1.9Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 0.67,
    y: 3.04,
    width: 10.15,
    height: 10.15
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 0.67,
    y1: 3.04,
    x2: 10.82,
    y2: 13.19
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 10.82,
    y1: 3.04,
    x2: 0.67,
    y2: 13.19
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew288);
export default __webpack_public_path__ + "static/media/Symbolpack_New_288.6a3ed1578d6d9403fbdc6813f77be1e6.svg";
export { ForwardRef as ReactComponent };